// @ts-nocheck

// import { Component, ContentChild, ElementRef, Input, OnInit, AfterViewChecked, ViewChild, ViewChildren, HostBinding } from '@angular/core';
import {
    Component,
    ContentChild,
    ElementRef,
    Input,
    OnInit,
    OnDestroy,
    AfterViewChecked,
    ViewChild,
    ViewChildren,
    HostBinding
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as THREE from 'three';
// import { Scene, GLTFLoader, RGBELoader, render } from 'THREE';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {TrackballControls} from 'three/examples/jsm/controls/TrackballControls.js';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader';
import {OrthographicCamera} from 'three/src/cameras/OrthographicCamera';
import {threadId} from 'worker_threads';
import {DOCUMENT} from '@angular/common';
import {DataService} from 'src/app/_services/data.service';
import {jsDocComment} from '@angular/compiler';
import {isJSDocThisTag} from 'typescript';
import {DRACOLoader} from 'three/addons/loaders/DRACOLoader.js';
import {FlatPropetiesOntheFlyComponent} from '../flat-propeties-onthe-fly/flat-propeties-onthe-fly.component';
import {numberFromString} from 'src/app/_core/_function/numberFromString';
import * as TWEEN from 'tween.js/src/Tween.js';
import {throttle} from 'lodash';
import {BuildingFlat} from "../../_core/_interface/buildingFlat"; // Add this at the top of your file


//FPS MONITORING TOOL
// import Stats from 'three/examples/jsm/libs/stats.module'

// const stats = new Stats()
// // stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
// //stats.dom.style.marginLeft = "10px";

// document.body.appendChild(stats.dom);


@Component({
    selector: 'app-threejs',
    templateUrl: './threejs.component.html',
    styleUrls: ['./threejs.component.scss']
})


export class ThreejsComponent implements OnInit, OnDestroy {

    // windowW = document.getElementsByClassName('mat-tab-body-wrapper')[0].clientWidth;
    // windowH =  document.getElementsByClassName('mat-tab-body-wrapper')[0].clientHeight;
    // camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 500);
    camera;
    controls;
    scene = new THREE.Scene();
    model = null;
    renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        logarithmicDepthBuffer: true,
        precision: 'highp'
    });
    // new THREE.WebGLRenderer( { alpha: true } );

    pointer = new THREE.Vector2();
    raycaster = new THREE.Raycaster();
    container = document.createElement('div');
    oldMaterial: any = [];
    freeArray: any[] = [];
    waitingArray: any[] = [];
    soldArray: any[] = [];
    status: string = '';
    mouseDown: boolean = false;
    @ContentChild("contentChild") contentChild: ElementRef;
    // @ViewChild('canvas') canvas:ElementRef;
    @ViewChild('canvas', {static: true}) foo: any;

    @Input()
    currentBuilding: any;
    @Input()
    flat: any;
    @Input()
    mainSpirikal: any;
    floorMaterial: any;
    projId: string = '';
    builUid: string = '';
    loaded: number = 0;
    loadingCounter = 0;
    screenW = 0;
    screenH = 0;
    touchStartY: number;
    inFlatProperties: boolean = false;
    flatNumber: any = '';
    curFlatNumber: any = '';
    // (ViewProjectMarkerComponent, { static: true })
    @ViewChild(FlatPropetiesOntheFlyComponent) childShowPropertiesOnTheFly;
    startPosition: any;
    lastMouseY = null;
    lastMouseX = null;
    notMoving: boolean = false;
    arrayToMark: any[] = [];
    endTime: number;
    startTime: number;
    timeDiff: number;
    canvasHolder: any;
    isOnTheFly: boolean = false;
    isFlatPage: boolean = false;
    onMouseMove: (event: MouseEvent) => void;
    onWheel: (event: WheelEvent) => void;
    isDescktop: boolean = true;
    isCameraAnimated = false;
    currentFlat: BuildingFlat;
    constructor(private hostElement: ElementRef, private route: ActivatedRoute, private router: Router, private dataService: DataService) {
        this.onMouseMove = this.onMouseMove.bind(this); // 60fps, adjust as needed
        this.onWheel = this.onWheel.bind(this); // 60fps, adjust as needed
    }

    public ngOnDestroy(): void {
        var freeSceneResources = () => {
            const cleanMaterial = material => {
                material.dispose()
                // dispose textures
                for (const key of Object.keys(material)) {
                    const value = material[key]
                    if (value && typeof value === 'object' && 'minFilter' in value) {
                        value.dispose()
                    }
                }
            }
            this.renderer.dispose()
            this.scene.traverse(object => {
                if (!object.isMesh) return
                object.geometry.dispose()
                if (object.material.isMaterial) {
                    cleanMaterial(object.material)
                } else {
                    // an array of materials
                    for (const material of object.material) cleanMaterial(material)
                }
            })
        }
        freeSceneResources();
    }

    ngOnInit(): void {
        this.isDescktop = window.innerWidth > 1200;
        this.isFlatPage = document.getElementsByClassName('isFlat').length > 0;
        this.route.url.subscribe(segment => {
            if (segment.length > 6) {
                this.inFlatProperties = true;
            }
        });
        if (window.innerWidth > 1200) {
            this.screenW = window.innerWidth - 80;
            this.screenH = window.innerHeight - 78;
        } else {
            this.screenW = window.innerWidth;
            this.screenH = window.innerHeight - 186;
        }

        if (this.inFlatProperties) {
            this.canvasHolder = document.getElementsByClassName('flat-composite-bottom');
        } else {
            this.canvasHolder = document.getElementsByClassName('holder-3d-project');
        }

        this.camera = new THREE.PerspectiveCamera(45, this.canvasHolder[0].offsetWidth / this.canvasHolder[0].offsetHeight, 0.1, 1000);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true; // Enable damping
        this.controls.dampingFactor = 0.05; // Adjust the damping factor as needed
        this.controls.enablePan = false;


        this.zoomControls = new TrackballControls(this.camera, this.renderer.domElement)
        this.zoomControls.noRotate = true;
        this.zoomControls.noPan = true;
        this.zoomControls.noZoom = false;
        this.zoomControls.zoomSpeed = 0.7;

        this.zoomControls.minDistance = 60;
        this.zoomControls.maxDistance = 170;


        this.dataService.showFlatProperties.subscribe(item => {
            this.reset(event);
            this.flat = item;
            if (this.isFlatPage) {
                this.setFlat();
            }
        });

        this.projId = this.currentBuilding.projId;
        this.builUid = this.currentBuilding.uid;
        this.container.setAttribute('style', 'padding: 0; margin: 0;',);

        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.screenW, this.screenH);

        this.dataService.floorsNumbers.subscribe(floorsNumbers => {
        });

        this.dataService.itemsToFilter.subscribe(flats => {
            this.reset('');
            flats.forEach(flat => {
                this.disableFlat(flat);
            })
        });

        this.dataService.markerFlatNumber.subscribe(flatForMarking => {
            this.markerFlat(flatForMarking);
        });

        this.dataService.markerFlatNumberClick.subscribe(flatForClick => {
            this.openFlyMenu(flatForClick);
        });

        this.renderer.outputEncoding = THREE.sRGBEncoding;
        if (this.scene) {
            if (this.renderer && (this.renderer.info.memory.geometries || this.renderer.info.memory.programs || this.renderer.info.memory.textures)) {
                console.log("VIEW.clear: geometries=" + this.renderer.info.memory.geometries + " programs=" + this.renderer.info.memory.programs + " textures=" + this.renderer.info.memory.textures);
            }
        }
        this.foo.nativeElement.prepend(this.renderer.domElement);
        this.modelLoader();
        this.setupEventListeners();

        //added a render loop. This is a must have for a smooth performance.
        this.renderer.setAnimationLoop(animate);
        var that = this;

        function animate() {
            //stats.begin()

            // Sync trackball and orbit controls
            const target = that.controls.target;
            that.controls.update();
            that.zoomControls.target.set(target.x, target.y, target.z);
            that.zoomControls.update();

            that.renderer.render(that.scene, that.camera);
            //stats.end()
            //stats.update();
        }
    }


    setupEventListeners() {
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('click', this.onMouseClick);
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('wheel', this.onWheel);
        window.addEventListener('mousedown', this.onMouseDown);
        window.addEventListener('pointerup', this.pointerUp);
        //window.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
        //window.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
        //window.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
    }

    // Throttle the render calls
    // throttledRender = throttle(() => {
    //   this.controls.update();
    //   this.renderer.render(this.scene, this.camera);
    // }, 100); // Adjust the delay as needed


    onTouchStart(event: TouchEvent) {
        this.mouseDown = true;
        this.startTime = new Date().getTime();
        this.lastMouseY = event.touches[0].clientY;
        this.lastMouseX = event.touches[0].clientX;
        // this.pointer.x = (event.touches[0].clientX / this.screenW) * 2 - 1;
        // this.pointer.y = -(event.touches[0].clientY / this.screenH) * 2 + 1.2;
    }

    onTouchMove(event: TouchEvent) {
        this.pointer.x = (event.touches[0].clientX / this.screenW) * 2 - 1;
        this.pointer.y = -(event.touches[0].clientY / this.screenH) * 2 + 1.2;
        //this.raycaster.setFromCamera(this.pointer, this.camera);
    }

    onTouchEnd(event: TouchEvent) {
        this.mouseDown = false;
        this.endTime = new Date().getTime();
        this.timeDiff = this.endTime - this.startTime;

        if (this.timeDiff < 300 && !this.isFlatPage) {
            const intersects = this.raycaster.intersectObjects(this.scene.children);
            if (intersects.length > 0) {
                this.flatNumber = intersects[0].object.name.slice(4);
                if (this.flatNumber.includes("_")) {
                    let flatNumber = this.flatNumber.substring(0, this.flatNumber.indexOf('_'));
                    this.flatNumber = flatNumber;
                }
                this.childShowPropertiesOnTheFly.getFlatOnClick(this.flatNumber);
                this.isOnTheFly = true;
            }
        }
    }


    isOnTheFlyF($event) {
        this.isOnTheFly = $event;
    }

    setBuildingZoom() {
        if (this.inFlatProperties) {
            this.camera.position.set(0, 0, 135);
            this.scene.position.y = -38;
        } else {
            this.camera.position.set(0, 0, 118);
            this.scene.position.y = -42;
        }
    }

    // disableFlat(flat) {
    //   let curFlat = flat;
    //   if (flat) {
    //     let curFlatNumber;
    //     if (flat.number) {
    //       curFlatNumber = flat.number;
    //     } else {
    //       curFlatNumber = flat;
    //     }
    //     let flatArray: any[] = [];
    //     if (this.scene.children[4]) {
    //       flatArray = this.scene.children[4].children;
    //     }
    //     flatArray.forEach(flat => {
    //       let flatNumber = flat.name.slice(4)
    //       if (curFlatNumber === flatNumber) {
    //         if (curFlat.status === 'free' || curFlat.status === '') {
    //           flat.children.forEach(mesh => {
    //             this.oldMaterial.push({ uuid: mesh.uuid, material: mesh.material });
    //             var material2 = mesh.material.clone();
    //             let material3 = mesh.material;
    //             material2.color.set(0x38d147);
    //             mesh.material = material2;
    //           })
    //         }

    //         if (curFlat.status === 'sold' || curFlat.status === '') {
    //           flat.children.forEach(mesh => {
    //             this.oldMaterial.push({ uuid: mesh.uuid, material: mesh.material });
    //             var material2 = mesh.material.clone();
    //             let material3 = mesh.material;
    //             material2.color.set(0xF44336);
    //             mesh.material = material2;
    //           })
    //         }

    //         if (curFlat.status === 'waiting' || curFlat.status === '') {
    //           flat.children.forEach(mesh => {
    //             this.oldMaterial.push({ uuid: mesh.uuid, material: mesh.material });
    //             var material2 = mesh.material.clone();
    //             let material3 = mesh.material;
    //             material2.color.set(0xfca311);
    //             mesh.material = material2;
    //           })
    //         }
    //       }
    //     });
    //   }
    // }


    disableFlat(flat) {
        let curFlat = flat;
        if (flat) {
            let curFlatNumber = flat.number || flat;
            // let flatArray = this.model?.children || [];
            let flatArray = [];
            flatArray = this.addFlats();
            flatArray.forEach(flat => {
                let flatNumber = flat.name.slice(4);
                if (curFlatNumber + '' === flatNumber + '') {
                    flat.children.forEach(mesh => {
                        this.oldMaterial.push({uuid: mesh.uuid, material: mesh.material});
                        const material = mesh.material.clone();
                        material.color.set(curFlat.status === 'free' ? 0x38d147 : curFlat.status === 'sold' ? 0xF44336 : 0xfca311);
                        mesh.material = material;
                    });
                }
            });
        }
    }


    markerFlat(flat) {
        this.reset('asda')
        if (flat) {
            this.currentFlat = flat;
            // let flatArray = this.model.children;
            const flatArray = this.addFlats() || [];
            flatArray.forEach(flat => {
                let flatNumber = flat.name.slice(4)
                if (String(this.currentFlat.number) === String(flatNumber)) {
                    flat.children.forEach(mesh => {
                        this.oldMaterial.push({uuid: mesh.uuid, material: mesh.material});
                        var material2 = mesh.material.clone();
                        let material3 = mesh.material;
                        // material2.color.set(0x267fbf);
                        material2.color.set(0x38d147);
                        if (this.currentFlat.status === 'sold') {
                            material2.color.set(0xF44336);
                        }
                        if (this.currentFlat.status === 'waiting') {
                            material2.color.set(0xfca311);
                        }
                        mesh.material = material2;
                    });
                    this.childShowPropertiesOnTheFly.getFlat(flatNumber, event.clientX, event.clientY);
                }
            });
        }
    }

    envmaploader = new THREE.PMREMGenerator(this.renderer);
    envmap;

    modelLoader() {
        new RGBELoader()
                .setPath('')

                // .load('../../../../../assets/img/night-sky.hdr', (texture) => {
                .load('../../../../../assets/img/rocky_ridge_puresky_1k.hdr', (texture) => {
                    // .load('https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/dgvD5I9UrwRHLnoU2RVF%2FIbwrFKU1oHSQaeNEnIkN2Xd2H0a7Z6kswQv3D%2F1668589203244_night-small.hdr?alt=media', (texture) => {
                    // .load('https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/dgvD5I9UrwRHLnoU2RVF%2F2Xd2H0a7Z6kswQvinteriorSimulations%2F1676985694945_belfast_farmhouse_4k.hdr?alt=media', (texture) => {

                    //   .load('https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/5z97bOrCj4PGDryAzDOS%2Fa246afb5-427c-4921-927b-795020264f93-1contactMenPic%2F1677500230530_belfast_farmhouse_4k-2.hdr?alt=media', (texture) => {
                    // .load('https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/5z97bOrCj4PGDryAzDOS%2F2F4XjFJz9UMyTQlmenuLogo%2F1680428134426_02042023.hdr?alt=media', (texture) => {

                    //  .load('https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/5z97bOrCj4PGDryAzDOS%2FI8hwg4FFldSYcP8menuLogo%2F1678031589752_mpumalanga_veld_puresky_4k.hdr?alt=media', (texture) => {
                    texture.mapping = THREE.EquirectangularReflectionMapping;
                    // this.scene.background = texture;
                    this.scene.environment = texture;

                    const light2 = new THREE.AmbientLight(0x404040); // soft white light
                    this.scene.add(light2);
                    this.envmap = this.envmaploader.fromCubemap(texture);
                    const pointLight = new THREE.PointLight(0xf3f1dd, 1, 100);
                    const pointLight2 = new THREE.PointLight(0xffffff, 1, 100);
                    pointLight.castShadow = false;
                    pointLight2.castShadow = false;
                    pointLight.position.set(0, 73, 2);
                    pointLight2.position.set(30, 30, 30);
                    this.scene.add(pointLight);
                    this.scene.add(pointLight2);

                    // const light3 = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.7 );
                    // this.scene.add( light3 );

                    this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
                    const sphereSize = 1;
                    // const pointLightHelper = new THREE.PointLightHelper(pointLight2, sphereSize);
                    // this.scene.add(pointLightHelper);


                    ///////////////  try make reflaction Start


                    let texture2 = new THREE.CanvasTexture();
                    texture.wrapS = THREE.RepeatWrapping;
                    texture.wrapT = THREE.RepeatWrapping;

                    //repeat the wrapping 10 (x) and 6 (y) times
                    texture.repeat.x = 10;
                    texture.repeat.y = 6;

                    const ballMaterial = {
                        clearcoat: 1.0,
                        cleacoatRoughness: 0.2,
                        metalness: 0,
                        roughness: 0.1,
                        color: 0xffffff,
                        normalMap: texture,
                        normalScale: new THREE.Vector2(0.01, 0.01),
                        envMap: texture,
                        transparent: true,
                        envMapIntensity: 0.2,
                        transmission: 0.05,
                        thickness: 1.0,    // Thickness for refraction calculation
                        // ior: 1.6
                    };


                    const ballMaterialMobile = new THREE.MeshStandardMaterial({
                        color: new THREE.Color(0xFFFFFF),
                        opacity: 0.5,
                        transparent: true,
                        side: THREE.DoubleSide,
                        reflectivity: 0.5,
                        specular: new THREE.Color(0xFFFFFF)
                        // envMap: texture,
                        // envMapIntensity: 0.2,
                        // normalMap: texture,
                        // normalScale: new THREE.Vector2(0.01, 0.01),
                    });
                    //ballMaterialMobile.color = THREE.Color(0xFFFFFF)

                    let ballMat;
                    //alert(this.isDescktop)
                    if (this.isDescktop) {
                        ballMat = new THREE.MeshPhysicalMaterial(ballMaterial);
                    } else {
                        ballMat = ballMaterialMobile;
                    }
                    //add material setting


                    //////////////   try make reflaction End


                    const draco = new DRACOLoader();
                    draco.setDecoderConfig({type: 'js'});
                    draco.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

                    // this.render();
                    const loader = new GLTFLoader().setPath('');
                    loader.setDRACOLoader(draco);
                    loader.load(
                            //"../../../../../assets/models/amram-eytan.glb",
                            // "../../../../../assets/models/amram-eytan-v2.glb",

                            // '../../../../../assets/img/greenSpace_with_names.glb',
                            // "../../../../../assets/models/optimized4.glb",
                            // "../../../../../assets/models/FINAL_test.glb",
                            // "../../../../../assets/models/amram-eytan.glb",
                            this.currentBuilding.glb,
                            // 'https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/5z97bOrCj4PGDryAzDOS%2Fnc1CTrPZvnWY0E3contactMenPic%2F1723389196369_faniyan1.glb?alt=media', // 11082024
                            // 'https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/5z97bOrCj4PGDryAzDOS%2F2F4XjFJz9UMyTQlmenuLogo%2F1680426879525_greenSpace_final5.glb?alt=media', // 11082024
                            // 'https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/dgvD5I9UrwRHLnoU2RVF%2FIbwrFKU1oHSQaeNEnIkN2Xd2H0a7Z6kswQv3D%2F1725182049202_Netanya_Ben_Gurion25_For_3D_v03.glb?alt=media', // new model Avram-Amram


                            (gltf) => {
                                // gltf.scene.scale.set(0.5, 0.5, 0.5);
                                // this.scene.position.set(0,-21,0);
                                this.model = gltf.scene;
                                gltf.scene.traverse((child) => {
                                    if ((child as THREE.Mesh).isMesh) {
                                        const m = child as THREE.Mesh
                                        if (this.isDescktop) {
                                            m.receiveShadow = true
                                            m.castShadow = true
                                        } else {
                                            m.receiveShadow = false
                                            m.castShadow = false
                                        }

                                    }
                                    if ((child as THREE.Light).isLight) {
                                        const l = child as THREE.Light
                                        l.castShadow = true
                                        l.shadow.bias = -0.003
                                        l.shadow.mapSize.width = 512
                                        l.shadow.mapSize.height = 512
                                    }
                                    if (child.type === 'Mesh') {


                                        if (child.material.name === 'Glass') {

                                            child.material.dispose();
                                            child.material = ballMat.clone();
                                            child.material.transparent = 'true';
                                            child.material.opacity = .9;
                                            child.material.needsUpdate = true;

                                            // child.material.envmap;
                                            // child.material.envmap.set(this.envmap)

                                        }
                                        if (child.material.name === 'Glass_Rails') {
                                            // child.material.transparent = 'true';
                                            // child.material.opacity = 0.5;
                                            child.material.dispose();
                                            child.material = ballMat.clone();
                                            //child.material.transmission = 1;
                                            child.material.needsUpdate = true;

                                        } else {
                                            child.material.transparent = 'false';
                                        }
                                        if (child.name === 'floor') {
                                            child.material.transparent = true;
                                            child.material.opacity = 0.2;
                                            child.material.needsUpdate = true;
                                            this.floorMaterial = child.material;
                                        }
                                        if (child.name === 'Plane_Back') {
                                            child.material.transparent = true;
                                            child.material.opacity = 0.8;
                                            child.material.needsUpdate = true;
                                            this.floorMaterial = child.material;
                                        }
                                    }
                                })

                                this.scene.add(gltf.scene);


                                // Traverse all objects in the scene
                                this.scene.traverse((object) => {
                                    // Check if the object has a material
                                    if (object.isMesh && object.material) {
                                        const material = object.material;

                                        //Flickering fix
                                        // Ensure mipmapping is enabled (for textures)
                                        if (material.map) {
                                            material.map.generateMipmaps = true;
                                            material.map.minFilter = THREE.LinearMipMapLinearFilter;
                                            material.map.magFilter = THREE.LinearFilter;
                                            material.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
                                            material.map.needsUpdate = true;
                                        }

                                        // Ensure normal maps, bump maps, and other texture-based maps also have mipmaps
                                        const textureMaps = ['bumpMap', 'normalMap', 'displacementMap', 'roughnessMap', 'metalnessMap', 'aoMap', 'emissiveMap'];
                                        textureMaps.forEach((mapName) => {
                                            if (material[mapName]) {
                                                material[mapName].generateMipmaps = true;
                                                material[mapName].minFilter = THREE.LinearMipMapLinearFilter;
                                                material[mapName].magFilter = THREE.LinearFilter;
                                                material[mapName].anisotropy = this.renderer.capabilities.getMaxAnisotropy();
                                                material[mapName].needsUpdate = true;
                                            }
                                        });

                                    }
                                });


                                this.camera.position.set(0, 0, 150);
                                this.scene.position.y = -42;

                            },
                            (xhr) => {
                                this.loaded = Math.floor((xhr.loaded / xhr.total) * 100);
                                if (Math.floor((xhr.loaded / xhr.total) * 100) === 100) {
                                    setTimeout(() => {
                                        this.setFlat();
                                    }, 3000)
                                }
                            },
                            (error) => {
                                console.log(error)
                            }
                    );


                    this.controls.minDistance = 60;
                    this.controls.maxDistance = 170;
                    this.controls.target.set(0, 0, -0.2);
                    this.controls.maxPolarAngle = 1.5;
                    this.controls.minPolarAngle = 1.5;
                    this.controls.enableDamping = true;
                    this.controls.dampingFactor = 0.05; // You can adjust the damping factor as needed

                    //we use trackball controls for smooth zoom
                    this.controls.enableZoom = false;
                    this.controls.zoomSpeed = 0.6;
                    this.controls.rotateSpeed = 2;


                    // this.controls.mouseButtons.left = THREE.MOUSE.PAN;
                    // this.controls.mouseButtons = {
                    //   LEFT: THREE.MOUSE.ROTATE,
                    //   MIDDLE: THREE.MOUSE.DOLLY,
                    //   RIGHT: THREE.MOUSE.PAN
                    // }
                    this.controls.panSpeed = 2;
                    this.controls.mouseButtons.LEFT = THREE.MOUSE.ROTATE;
                    this.controls.mouseButtons.RIGHT = THREE.MOUSE.PAN;
                    // this.controls.panningMode = THREE.HorizontalPanning;
                    //         this.controls.minPanAngle = -Infinity;
                    // this.controls.maxPanAngle = Infinity;
                    // this.controls.panAngle = 1;
                    // this.controls.panAxis = new THREE.Vector3(0, 2, 0);
                    this.controls.update();


                    // window.addEventListener('resize', this.onWindowResize);
                    // window.addEventListener('click', this.onMouseClick);
                    // window.addEventListener('mousemove', this.onMouseMove);
                    // window.addEventListener('wheel', this.onWheel);
                    // window.addEventListener('mousedown', this.onMouseDown);
                    // window.addEventListener('pointerup', this.pointerUp);
                    // this.controls.addEventListener( 'change', this.onChange);
                    // window.addEventListener('mouseover', this.onMouseOver);


                    // this.dataService.flatStatusClass.subscribe(item => {
                    //   this.status = item;
                    //   this.reset('');
                    //   this.setColor(this.status);
                    // })
                });
    }


    setFlat() {
        if (this.flat) {
            this.curFlatNumber = this.flat.number;
            let curFlatNumber = this.flat.number;

            // let flatArray = this.model.children;
            let flatArray = [];
            flatArray = this.addFlats();

            flatArray.forEach(flat => {
                // flatChildrens.children.forEach(flat => {
                let flatNumber = flat.name.slice(4)
                if (curFlatNumber === flatNumber) {
                    flat.children.forEach(mesh => {
                        this.oldMaterial.push({uuid: mesh.uuid, material: mesh.material});
                        var material4 = mesh.material.clone();
                        let material3 = mesh.material;
                        material4.color.set(0x38d147);

                        if (this.currentFlat.status === 'sold') {
                            material4.color.set(0xF44336);
                        }
                        if (this.currentFlat.status === 'waiting') {
                            material4.color.set(0xfca311);
                        }
                        // material4.color.set(0xfff8be);
                        if (mesh.material.name === 'Glass') {
                            material4.transmission = 0.8;
                            material4.transparent = 'true';
                            material4.opacity = 0.3;
                            material4.needsUpdate = true;
                        }
                        // material2.transparent = 'true';
                        // material2.opacity = 0.1;
                        mesh.material = material4;
                    })
                }
            });
            // });
        }
    }

    addFlats() {
        let flatArray = [];
        if (this.model) {
            // this.model.children.forEach(flat => {
            if (this.model.children[0].name === '' && this.model.children[0].children[0].name === '') {
                this.model.children.forEach(flatChildren => {
                    flatChildren.children.forEach(flatchildren2 => {
                        flatchildren2.children.forEach(flat => {
                            if (flat.name.includes("flat")) {
                                flatArray.push(flat);
                            }
                        });
                    });
                })
                return flatArray;
            }
            if (this.model.children[0].name !== '') {
                this.model.children.forEach(flat => {
                    if (flat.name.includes("flat")) {
                        flatArray.push(flat);
                    }
                });
                // flatArray  = this.model.children;
                return flatArray;
            }


            // })
            this.model.children.forEach(flatChildren => {
                flatChildren.children.forEach(flat => {
                    if (flat.name.includes("flat")) {
                        flatArray.push(flat);
                    }
                });
            })
        }
        return flatArray;
    }


    showAllobjects() {
        if (this.model) {
            // let flatArray = this.model.children;
            let flatArray = [];
            flatArray = this.addFlats();
            let flatArrayNames = flatArray.map(flat => flat.name.slice(4));
        }
    }

    pointerUp = (event) => {
        this.mouseDown = false;
        this.endTime = new Date().getTime();
        // Calculate the time difference in milliseconds
        this.timeDiff = this.endTime - this.startTime;
    }
    onMouseDown = (event) => {
        this.mouseDown = true;
        this.startTime = new Date().getTime();

        let startPlace = this.pointer.y;
        this.lastMouseY = event.clientY;
        this.lastMouseX = event.clientX;
        setTimeout(() => {
            if (event.clientY - 5 > this.pointer.y) {
                // this.scene.position.y = this.scene.position.y + 5;
            }
        }, 1000);

        // function numberFromString(str: string): number {
        //   const num = str.match(/\d+/);
        //   return num ? parseInt(num[0], 10) : 0;
        // }

        this.flatNumber = numberFromString(this.flatNumber);
        const zoomLevel = 0.1;
        const distance = 10; // or any other desired distance from the object

        const intersects = this.raycaster.intersectObjects(this.scene.children);
        if (intersects[0]) {
            this.flatNumber = intersects[0].object.name.slice(4)
            if (this.flatNumber.includes("_")) {
                let flatNumber = this.flatNumber.substring(0, this.flatNumber.indexOf('_'))
                this.flatNumber = flatNumber;
            }
            setTimeout(() => {
                if (this.mouseDown === false) {
                    // this.camera.position.set(intersects[0].point.x + distance * zoomLevel, this.camera.position.y + 120, intersects[0].point.z + distance * zoomLevel);
                    // this.render();


                    //Wait for animation to finish
                    if (this.isCameraAnimated) {
                        return;
                    }


                    const endPosition = new THREE.Vector3(intersects[0].point.x + distance * zoomLevel, this.camera.position.y + 120, intersects[0].point.z + distance * zoomLevel);

                    // Set the initial position of the object
                    let duration = 300;
                    let letanimate: boolean = true;
                    const startPosition = this.camera.position;


                    const saved_min_distance = this.controls.minDistance;
                    this.controls.minDistance = this.controls.getDistance();
                    this.zoomControls.minDistance = this.controls.minDistance;
                    // Create a new tween that changes the position of the cube
                    this.controls.enabled = false;
                    this.zoomControls.enabled = false;
                    this.isCameraAnimated = true;
                    const tween = new TWEEN.Tween(startPosition)
                            .to({x: endPosition.x, y: 0, z: endPosition.z}, duration) // Final position and duration
                            .easing(TWEEN.Easing.Quadratic.InOut)
                            .onUpdate(() => {
                                // Update the position of the object during the tween
                                this.controls.update();
                                this.zoomControls.update();
                            })
                            .onComplete(() => {
                                // Re-enable controls or any other final actions
                                this.controls.enabled = true;
                                this.zoomControls.enabled = true;

                                this.controls.minDistance = saved_min_distance;
                                this.zoomControls.minDistance = this.controls.minDistance;
                                this.isCameraAnimated = false;

                                console.log("Animation complete");
                            })
                            .start(); // Start the tween

                    // Call the TWEEN update function in the render loop to update the tween  // Andrey remove it
                    let animate = (() => {
                        if (letanimate) {
                            requestAnimationFrame(animate);
                            TWEEN.update();
                            this.render();
                        }
                    })

                    animate();


                    setTimeout(() => {
                        letanimate = false
                    }, duration);

                }

            }, 100);
            // this.camera.position.set(intersects[0].point.x + distance * zoomLevel, intersects[0].point.y + 10, intersects[0].point.z + distance * zoomLevel);

        }
    }


    onWheel = (event) => {
        //this.controls.minDistance = 40;
        this.controls.update(); // Ensure damping is applied
        this.zoomControls.update();
        // const zoomFactor = event.deltaY > 0 ? 1.1 : 0.9;
        // const targetPosition = new THREE.Vector3(
        //   this.camera.position.x * zoomFactor,
        //   this.camera.position.y * zoomFactor,
        //   this.camera.position.z * zoomFactor
        // );

        // this.tweenCameraTo(targetPosition, 1000); // 1000 ms duration for zooming
    }
    onMouseMove = (event) => {
        // if (!this.mouseDown  && !this.isFlatPage) {
        //   this.render();
        // }
        // event.stopPropagation();

        // test hover
        this.pointer.x = (event.clientX / this.screenW) * 2 - 1;
        this.pointer.y = -(event.clientY / this.screenH) * 2 + 1.2;
        // this.currentBuilding
        // this.currentBuilding.floors[0].floor.flats[0].status

        this.raycaster.setFromCamera(this.pointer, this.camera);
        const intersects = this.raycaster.intersectObjects(this.scene.children);

        if (!this.mouseDown && !this.isFlatPage) {
            if (this.isOnTheFly) {
                return;
            }
            if (intersects.length > 0) {
                if (intersects[0].object.name === 'flat_penthouse_1' || intersects[0].object.name === 'flat_penthouse_3' || intersects[0].object.name === 'flat_penthouse_2') {
                    intersects[0].object.name = 'flat_16'
                } else {
                    if (intersects[0].object
                            && intersects[0].object.name !== 'Bld_7'
                            && intersects[0].object.name !== 'Bld_8'
                            && intersects[0].object.name !== 'Bld_9'
                            && intersects[0].object.name !== 'Bld_4'
                            && intersects[0].object.name !== 'Bld_5'
                            && intersects[0].object.name !== 'Bld_6'
                            && intersects[0].object.name !== 'Bld_4'
                            && intersects[0].object.name !== 'Bld_3'
                            && intersects[0].object.name !== 'Bld_2'
                            && intersects[0].object.name !== 'Bld_1') {
                        // let flatNumber = intersects[0].object.name.slice(4)
                        console.log(intersects[0].object.name);
                        // if(intersects[0].object.name.includes('flat_sold')){
                        //   this.flatNumber = '3';
                        // }
                        this.flatNumber = intersects[0].object.name.slice(4)
                        if (this.flatNumber.includes("_")) {
                            let flatNumber = this.flatNumber.substring(0, this.flatNumber.indexOf('_'))
                            this.flatNumber = flatNumber;
                        }
                        console.log(this.flatNumber);
                        if (!(this.curFlatNumber === this.flatNumber) && this.flatNumber != 1) {
                            // setTimeout(() => {
                            this.reset(event);
                            this.childShowPropertiesOnTheFly.getFlat(this.flatNumber, event.clientX, event.clientY);
                            this.flat = {};
                            this.flat.number = this.flatNumber;
                            this.setFlat();
                            // }, 500);
                        }
                    }
                }

            }


        } else {
            if (this.mouseDown) {
                if (this.isOnTheFly) {
                    return;
                }
                        // this.controls.mouseButtons.LEFT = THREE.MOUSE.ROTATE;

                        // let absDifferY = Math.abs(this.lastMouseY - event.clientY);
                        // let absDifferX = Math.abs(this.lastMouseX - event.clientX);
                        // if (this.lastMouseY !== event.clientY) {
                        //   if (absDifferY > absDifferX) {
                        //     if (this.lastMouseY > event.clientY) {
                        //       if (this.controls.target.y > -30) {
                        //         this.controls.target.y = this.controls.target.y - absDifferY * 0.006;
                        //         // this.camera.position.y = this.controls.target.y - absDifferY * 0.002;
                        //       }
                        //     } else if (this.lastMouseY < event.clientY) {
                        //       if (this.controls.target.y < 15) {
                        //         this.controls.target.y = this.controls.target.y + absDifferY * 0.006;
                        //         // this.camera.position.y = this.controls.target.y + absDifferY * 0.002;
                        //       }
                        //     }
                        //     this.render();
                        //   }

                // } else {
                else if (this.mouseDown) {
                    if (this.isOnTheFly) {
                        return;
                    }
                    this.controls.mouseButtons.LEFT = THREE.MOUSE.ROTATE;

                }
            } else {
                console.log("not pushed!!!!!!!!!!!!!!!!!!!!!!!!!");
            }
        }
    };

    onFlatSelected(flat: any) {
        this.currentFlat = flat; // Store the received flat data for use in the parent
        console.log("Selected Flat:", this.currentFlat);
    }


    setColor(satus) {
        let floors = this.currentBuilding.floors;
        floors.forEach(floor => {
            floor.floor.flats.forEach(flat => {
                if (flat.status === 'free') {
                    if (flat.number) {
                        this.freeArray.push(flat.number);
                    } else {
                        this.freeArray.push(flat.floorTitle);
                    }
                } else if (flat.status === 'waiting') {
                    if (flat.number) {
                        this.waitingArray.push(flat.number);
                    } else {
                        this.waitingArray.push(flat.floorTitle);
                    }
                } else if (flat.status === 'sold') {
                    if (flat.number) {
                        this.soldArray.push(flat.number);
                    } else {
                        this.soldArray.push(flat.floorTitle);
                    }
                }
            })
        })
        // this.freeArray = ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15'];

        // let flatArray = this.model.children;
        let flatArray = [];
        flatArray = this.addFlats();
        // this.freeArray.forEach(freeFlat => {
        // freeArray.includes(freeFlat)

        flatArray.forEach(flat => {
            let flatNumber = flat.name.slice(4)
            let ifExistFree = this.freeArray.filter(number => number === flatNumber)
            let ifExistSold = this.soldArray.filter(number => number === flatNumber)
            let ifExistWating = this.waitingArray.filter(number => number === flatNumber)
            // if(this.freeArray.includes(flatNumber + '')){
            if (ifExistFree.length > 0 && this.status === 'free' || this.status === '') {
                flat.children.forEach(mesh => {
                    this.oldMaterial.push({uuid: mesh.uuid, material: mesh.material});
                    var material2 = mesh.material.clone();
                    let material3 = mesh.material;
                    // material2.color.set(0xff0000);
                    material2.color.set(0x38d147);
                    mesh.material = material2;
                })
            }

            if (ifExistSold.length > 0 && this.status === 'sold' || this.status === '') {
                flat.children.forEach(mesh => {
                    this.oldMaterial.push({uuid: mesh.uuid, material: mesh.material});
                    var material2 = mesh.material.clone();
                    let material3 = mesh.material;
                    material2.color.set(0xF44336);
                    mesh.material = material2;
                })
            }

            if (ifExistWating.length > 0 && this.status === 'waiting' || this.status === '') {
                flat.children.forEach(mesh => {
                    this.oldMaterial.push({uuid: mesh.uuid, material: mesh.material});
                    var material2 = mesh.material.clone();
                    let material3 = mesh.material;
                    material2.color.set(0xfca311);
                    mesh.material = material2;
                })
            }
        })
    }


    onMouseOver = (event) => {
        this.showAllobjects();
        // calculate pointer position in normalized device coordinates
        this.pointer.x = (event.clientX / this.screenW) * 2 - 1;
        this.pointer.y = -(event.clientY / this.screenH) * 2 + 1.2;
        // this.currentBuilding
        // this.currentBuilding.floors[0].floor.flats[0].status

        this.raycaster.setFromCamera(this.pointer, this.camera);
        const intersects = this.raycaster.intersectObjects(this.scene.children);


        if (intersects.length > 0) {
            if (intersects[0].object) {
                // let flatNumber = intersects[0].object.name.slice(4)
                if (intersects[0].object.name === 'flat_penthouse_1' || intersects[0].object.name === 'flat_penthouse_3') {
                    this.flatNumber = 'flat_16'
                }
                this.flatNumber = intersects[0].object.name.slice(4)

                if (this.flatNumber.includes("_")) {
                    let flatNumber = this.flatNumber.substring(0, this.flatNumber.indexOf('_'))
                    this.flatNumber = flatNumber;
                }
                setTimeout(() => {
                    if (this.flatNumber !== 1) {
                        this.childShowPropertiesOnTheFly.getFlat(this.flatNumber);
                    }
                }, 1000);

            }
        }
    };
    onMouseClick = (event) => {
        if (this.timeDiff < 300) {
            if (this.isOnTheFly) {
                this.childShowPropertiesOnTheFly.closePanel();
                this.isOnTheFly = false;
                return;
            }
        }
        this.showAllobjects();
        // calculate pointer position in normalized device coordinates
        this.pointer.x = (event.clientX / this.screenW) * 2 - 1;
        this.pointer.y = -(event.clientY / this.screenH) * 2 + 1.2;
        // this.currentBuilding
        // this.currentBuilding.floors[0].floor.flats[0].status

        this.raycaster.setFromCamera(this.pointer, this.camera);
        const intersects = this.raycaster.intersectObjects(this.scene.children);


        if (intersects.length > 0) {
            if (intersects[0].object) {
                //   const targetPosition = intersects[0].object.position.clone();
                //   const offset = targetPosition.clone().sub(this.camera.position);

                //  // Calculate new camera position based on selected object's position and zoom level
                //   this.camera.position.copy(targetPosition.clone().add(offset.multiplyScalar(0.01)));

                let object = intersects[0].object;


                // const position = new THREE.Vector3();
                // object.getWorldPosition(position);

                // Calculate new camera position based on selected object's position and desired zoom level
                const zoomLevel = 0.5;
                const distance = 10; // or any other desired distance from the object


                // let flatNumber = intersects[0].object.name.slice(4)
                this.flatNumber = intersects[0].object.name.slice(4)
                if (this.flatNumber.includes("_")) {
                    let flatNumber = this.flatNumber.substring(0, this.flatNumber.indexOf('_'))
                    this.flatNumber = flatNumber;
                }
                if (this.timeDiff < 300 && !this.isFlatPage) {
                    this.childShowPropertiesOnTheFly.getFlatOnClick(this.flatNumber);
                    this.isOnTheFly = true;
                    let isFlatProppertiesOpened = document.getElementsByClassName('move-canvas');
                    this.render();
                }


                if (this.flatNumber.includes(15)) {

                    var material2 = intersects[0].object.material.clone();
                    // material2.color.set(0xff0000);
                    intersects[0].object.material = material2;
                    this.render();
                    // this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + 'RWZKqNOwwypIV8Q']);
                }

            }
        }
    };

    openFlyMenu = (flat: BuildingFlat) => {
        if (this.isFlatPage) {
            return;
        }
        this.markerFlat(flat)
        this.childShowPropertiesOnTheFly.getFlatOnClick(flat.number);
        this.isOnTheFly = true;
        let isFlatProppertiesOpened = document.getElementsByClassName('move-canvas');

    };

    reset(e) {
        let flatArray;
        // flatArray = [];
        //   flatArray = this.addFlats();
        if (this.scene.children.length > 0) {
            // flatArray = this.model.children;
            flatArray = [];
            flatArray = this.addFlats();
        }

        this.oldMaterial.forEach(mesh => {
            flatArray.forEach(flat => {
                flat.children.forEach(mesh2 => {
                    if (mesh.uuid === mesh2.uuid) {

                        if (mesh2.uuid === mesh.uuid) {
                            mesh2.material = mesh.material;
                        }
                    }
                })
            })
        })
    }

    onWindowResize() {
        // window.location.reload();
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    render() {
        //this.controls.update();
        // TWEEN.update(); // Ensure TWEEN animations are updated
        this.renderer.render(this.scene, this.camera);
    }

}

